import "./App.css";
import { Routes, Route } from "react-router-dom";
import PaymentOptions from "./pages/PaymentOptions";
import NotFound from "./pages/NotFound";

function App() {
  return (
    <Routes>
      <Route path="/" element={<PaymentOptions />} />
      <Route path="/not-found" element={<NotFound />} />
    </Routes>
  );
}

export default App;
